import {AsyncActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/AsyncActDecorator';
import {consoleLogger} from '@gongxigames/framework/core';

export class LoadResourcesWithAfterPriorityAct extends AsyncActDecorator {
    public async execute(): Promise<void> {
        consoleLogger.log('ALL DEFAULT RESOURES LOADED');
        this.resourceManager.loadResourcesWithAfterPriority();
    }

    getName(): string {
        return 'LoadResourcesWithAfterPriorityAct';
    }
}